import(/* webpackMode: "eager" */ "/vercel/path0/web/web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/web/src/components/ClientProviders.tsx");
